import { useEffect } from 'react';
import { MyUserDetailsResponse } from 'src/apis/organisation-service/types';
import { Successful, useAxios } from 'src/hooks/use-axios';
import { OrganisationServiceRequest } from 'src/pages/settings/organisation/use-organisation-service';

type Options = {
  organisationService: OrganisationServiceRequest;
};

type Params = {
  organisationService: Successful<OrganisationServiceRequest>;
};

export function useMyUserDetails({ organisationService }: Options) {
  const userDetails = useAxios(
    (axios, signal, { organisationService }: Params) =>
      axios.request<MyUserDetailsResponse>({
        signal,
        url: organisationService.response.data._links.getMyUserDetails.href,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!organisationService?.response) return;
    userDetails.execute({ organisationService });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisationService?.response]);

  return userDetails;
}

export type MyUserDetailsRequest = ReturnType<typeof useMyUserDetails>;
